import React from 'react'

import { HeadingXLarge, HeadingMedium, Button, BodyText } from '@pb/components'
import {
  getLabelFromStorage,
  isArketBrand,
  isCosBrand,
  isMonkiBrand,
  isOtherStoriesBrand,
} from '@pb/utils'
import cn from 'classnames'

import { LIMIT_DAYS_TO_REVIEW } from '../../constants'
import styles from './ErrorContainer.scss'
import { Props, ErrorStatus } from './types'

const ErrorContainer: React.FC<Props> = ({ status, handleBackToReview }) => {
  const getTitle = (): string => {
    if (status === ErrorStatus.OLD) {
      return 'profile.unreviewedproducts.old.purchase.title'
    }

    if (status === ErrorStatus.ALREADY_REVIEWED) {
      return 'profile.unreviewedproducts.review.error.hi'
    }

    return 'profile.unreviewedproducts.connection.error.title'
  }

  const getSubTitle = (): string => {
    if (status === ErrorStatus.OLD) {
      return getLabelFromStorage('profile.unreviewedproducts.old.purchase.message').replace(
        '{0}',
        `${LIMIT_DAYS_TO_REVIEW}`,
      )
    }

    if (status === ErrorStatus.ALREADY_REVIEWED) {
      return 'profile.unreviewedproducts.review.error.already.reviewed'
    }

    return 'profile.unreviewedproducts.connection.error.message'
  }

  const getText = (): string => {
    if (status === ErrorStatus.OLD) {
      return 'profile.unreviewedproducts.old.purchase.other.items'
    }

    return 'profile.unreviewedproducts.connection.error.our.shop'
  }

  return (
    <section className={styles.errorContainer}>
      {isMonkiBrand ? (
        <>
          <HeadingXLarge className={styles.title} fullWidth bold>
            {getLabelFromStorage(getTitle())}
          </HeadingXLarge>
          <HeadingMedium>{getLabelFromStorage(getSubTitle())}</HeadingMedium>
        </>
      ) : isCosBrand ? (
        <>
          <BodyText preamble>{getLabelFromStorage(getTitle())}</BodyText>
          <BodyText meta>{getLabelFromStorage(getSubTitle())}</BodyText>
        </>
      ) : (
        <>
          <HeadingMedium fullWidth bold>
            {getLabelFromStorage(getTitle())}
          </HeadingMedium>
          <BodyText>{getLabelFromStorage(getSubTitle())}</BodyText>
        </>
      )}

      {status !== ErrorStatus.OLD && status !== ErrorStatus.ALREADY_REVIEWED && (
        <>
          {isMonkiBrand ? (
            <HeadingMedium Tag="p">{getLabelFromStorage(getText())}</HeadingMedium>
          ) : (
            <BodyText>{getLabelFromStorage(getText())}</BodyText>
          )}
          <Button Tag="a" href="/" className={styles.shoppingButton}>
            {getLabelFromStorage('profile.unreviewedproducts.connection.error.continue.shopping')}
          </Button>
        </>
      )}
      {(status === ErrorStatus.OLD || status === ErrorStatus.ALREADY_REVIEWED) && (
        <>
          {isOtherStoriesBrand && (
            <BodyText>
              {getLabelFromStorage('profile.unreviewedproducts.review.error.other.items')}
            </BodyText>
          )}

          <Button
            onClick={handleBackToReview}
            className={cn(styles.shoppingButton, isCosBrand && styles.uppercase)}
          >
            {getLabelFromStorage('profile.unreviewedproducts.review.error.back.to.reviews')}
          </Button>
          {isArketBrand && (
            <Button Tag="a" href="/" secondary className={styles.shoppingButton}>
              {getLabelFromStorage('profile.unreviewedproducts.connection.error.continue.shopping')}
            </Button>
          )}
        </>
      )}
    </section>
  )
}

export default ErrorContainer
